<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/dashboard">Home</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <a class="page-head__crumb" routerLink="/admin/dashboard">Admin</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <a class="page-head__crumb" routerLink="/admin/system-status">System status</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page"
        >Developer docs</span
      >
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">Developer environment</h1>
      </div>
      <div class="page-head__actions">
        <a mat-stroked-button routerLink="/admin/system-status">
          <app-icon name="arrow-left" [size]="16" /> Back to System status
        </a>
      </div>
    </div>
  </header>

  @if (loading()) {
    <div class="docs-skeleton" aria-label="Loading developer docs" aria-busy="true">
      <span class="sg-skeleton sg-skeleton--heading"></span>
      <span class="sg-skeleton sg-skeleton--text"></span>
      <span class="sg-skeleton sg-skeleton--text"></span>
      <span class="sg-skeleton sg-skeleton--text docs-skeleton__short"></span>
      <span class="sg-skeleton sg-skeleton--heading"></span>
      <span class="sg-skeleton sg-skeleton--text"></span>
      <span class="sg-skeleton sg-skeleton--text docs-skeleton__short"></span>
    </div>
  } @else if (error()) {
    <div class="sg-empty sg-empty--error sg-empty--bordered">
      <app-icon name="x-circle" [size]="40" />
      <p class="sg-empty__title">Couldn't load developer docs</p>
      <p class="sg-empty__desc">Something went wrong on our side.</p>
      <button mat-stroked-button type="button" (click)="load()">
        <app-icon name="refresh" [size]="18" /> Try again
      </button>
    </div>
  } @else if (content(); as md) {
    <mat-card appearance="outlined" class="docs-card">
      <mat-card-content>
        <article class="markdown-body" [innerHTML]="md | markdown"></article>
      </mat-card-content>
    </mat-card>
  }
</div>
